import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5877b73a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "PlatformArticle"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "PlatformArticle-header" }, " お役たちブログ ", -1))
const _hoisted_3 = { class: "PlatformArticle-list" }
const _hoisted_4 = {
  key: 0,
  class: "PlatformArticle-page"
}

import { onMounted, reactive, watch } from 'vue'
import { useRequest } from '@/util/useLoading'
import { getFrogArticleList } from '@/apis/frog'
import ArticleItem from './ArticleItem.vue'
import PaginationArrow from '@/components/common/PaginationArrow.vue'
import { getJapanTime as setStationTime } from '@/util/common'


export default /*#__PURE__*/_defineComponent({
  props: {
  frogArticleType: {
    type: String,
    default: null
  }
},
  setup(__props) {

const props = __props


onMounted(() => {
  getList()
})

const data: any = reactive({
  // 列表
  list: [],
  // 分页对象
  page: {
    currentPage: 1,
    pageSize: 3,
    total: 0,
    pages: 0
  }
})

// 获取文章列表
const [loading, getList] = useRequest(() => {
  const formData = {
    frogArticleType: props.frogArticleType,
    // frogArticleType: null,
    pageNum: data.page.currentPage,
    pageSize: data.page.pageSize
  }
  return getFrogArticleList(formData).then((res: any) => {
    if (res.code === '0') {
      data.list = res.data.records.map((item:any) => {
        return {
          ...item,
          createTime: item.frogArticleId === '151' ? '' : setStationTime(item.createTime)
        }
      })
      data.page.total = res.data.total
      data.page.pages = res.data.pages
    }
  })
})

// 分页切换
const pageChange = (page: number) => {
  data.page.currentPage = page
  getList()
}


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_unref(data).list.length !== 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).list, (item) => {
            return (_openBlock(), _createBlock(ArticleItem, {
              type: 0,
              key: item.frogArticleId,
              item: item
            }, null, 8, ["item"]))
          }), 128))
        ], 512), [
          [_directive_loading, _unref(loading)]
        ]),
        (_unref(data).page.pages !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(PaginationArrow, {
                currentPage: _unref(data).page.currentPage,
                pages: _unref(data).page.pages,
                "onUpdate:currentPage": pageChange
              }, null, 8, ["currentPage", "pages"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})